import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    content: 'You will be redirected to the {companyName} account shortly.',
    title: 'Thank you, your access has been created!',
  },
  fr: {
    content:
      'Vous allez être redirigé·e vers le compte de {companyName} d’ici un instant.',
    title: 'Merci, votre accès a été créé\xA0!',
  },
} as const);

export default locales;
